/* Teeshaa header search + cart drawer helpers (Oct 2026). The theme's own scripts still open, fill and update both panels;
   this only tidies what they print and how the page behaves behind them. */
(function () {
  var html = document.documentElement;
  // prices the theme prints in the drawer ("₹  35,000.00") -> "₹35,000"
  function tidy(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, fix = [];
    while ((n = w.nextNode())) if (/\d\.00\b|₹\s{2,}/.test(n.nodeValue)) fix.push(n);
    fix.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/(\d)\.00\b/g, '$1').replace(/₹\s+/g, '₹'); });
  }
  var cfg = { childList: true, subtree: true, characterData: true };
  function boot() {
    [].forEach.call(document.querySelectorAll('.nx .js-mini-cart-content, .nx .js-cart-total'), function (el) {
      tidy(el);
      var mo = new MutationObserver(function () { mo.disconnect(); tidy(el); mo.observe(el, cfg); });
      mo.observe(el, cfg);
    });
    // lock page scroll while the drawer or the search overlay is open
    var drawer = document.querySelector('.nx .js-mini-cart'), search = document.querySelector('.nx .header__search .detail-modal');
    function sync() {
      var open = (drawer && drawer.classList.contains('active')) || (search && search.classList.contains('active'));
      html.classList.toggle('hs-locked', !!open);
    }
    [drawer, search].forEach(function (el) { if (el) new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['class'] }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) drawer.classList.remove('active'); });
    // put the cursor in the field as soon as the search overlay opens
    if (search) new MutationObserver(function () { if (search.classList.contains('active')) { var i = search.querySelector('.search__input'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 60); } }).observe(search, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
